var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"formContent EC_width"},[_vm._m(0),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-left":"100px"}},[_c('login-vue')],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex1 display_center_ud"},[_c('div')])
}]

export { render, staticRenderFns }